import { render, staticRenderFns } from "./CustomersVoice.vue?vue&type=template&id=3c110a48&scoped=true&"
import script from "./CustomersVoice.vue?vue&type=script&lang=js&"
export * from "./CustomersVoice.vue?vue&type=script&lang=js&"
import style0 from "./CustomersVoice.vue?vue&type=style&index=0&id=3c110a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c110a48",
  null
  
)

export default component.exports